<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  reportsMethods,
  reportsComputed,
  exportMethods,
  erpFixMessages,
  mopMethods,
  mopComputed,
  kantoAdsMethods,
  kantoAdsComputed,
} from "@/state/helpers";
import Swal from "sweetalert2";
// import moment from 'moment';


export default {
  page: {
    title: "Kanto Ads Cashout",
  },
  data() {
    return {
      mcpCashouts: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "",
      sortDesc: true,
      sortOrder: "DESC",
      fields: [
        {
          key: "request_reference_number",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "store_name",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "store_owner",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "mobile",
          label: "SSS Mobile Number",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "status",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "transaction_date",
          label: "Transaction Date & Time",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "release_date",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "remarks",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "withdrawal_amount",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "wallet_type",
          sortable: false,
          tdClass: "align-middle",
        },

        {
          key: "account_name",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "account_number",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "email",
          sortable: true,
          tdClass: "align-middle",
        },
      ],
      isSearching: false,
      searchValue: {
        searchField: null,
        keyword: "",
        status: null,
        dateRange: null,
        sort: "w.id",
        orderDesc: true,
        cashoutType: null
      },
      searchList: [
        { text: "Search All", value: null },
        { text: "Request Reference Number", value: "w.txn_ref_id" },
        { text: "Store Name", value: "w.store_name" },
        { text: "Store Owner", value: "w.store_owner" },
        { text: "SSS Mobile Number", value: "w.sss_mobile_no" },
        { text: "Remarks", value: "w.remarks" },
        { text: "Wallet Type", value: "w.wallet_type" },
        { text: "Account Name", value: "w.account_name" },
        { text: "Account Number", value: "w.account_no" },
        { text: "Email", value: "w.recipient_email" },
      ],
      statusOptions: [
        { text: "All", value: null },
        { text: "Pending/Processing", value: "pending" },
        { text: "On Hold", value: "on hold" },
        { text: "Confirmed/Success", value: "confirmed" },
        { text: "Rejected/Failed", value: "rejected" },
      ],
      cashoutTypeOptions: [
        { text: "All", value: null },
        { text: "Eload", value: "eload" },
        { text: "Bills Payment", value: "bills" },
        { text: "Eload and Bills Payment", value: "eload_bills" },
        { text: "Bank Transfer/E-Wallet", value: "other" },
      ],
      isRange: null,
      rangeOptions: {
        mode: "range",
      },
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...reportsComputed,
    ...erpFixMessages,
    ...mopComputed,
    ...kantoAdsComputed,
  },
  async mounted() {
    this.changeTitle({ title: "Wallet Cashout" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Kanto Ads", to: { name: "" } },
        { text: "Wallet Cashout", to: { name: "KantoAdsCashout" } },
      ],
    });

    await this.getCashout();
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...mopMethods,
    ...kantoAdsMethods,
    async getCashout() {
      let params = {
        page: this.isSearching ? 1 : this.currentPage,
        limit: this.isSearching ? 10 : this.perPage,
        search: this.searchValue,
        sortBy: this.isSearching ? "" : this.sortBy,
        sortOrder: this.isSearching ? "DESC" : this.sortOrder,
      };

      await this.getMcpCashoutList(params).then(() => {
        this.mcpCashouts = this.mcpCashoutList;
      });

      this.isSearching = false;
    },
    async onExport() {
      let params = {
        module: "kantoads_cashout_logs",
        email: JSON.parse(localStorage.getItem("userData")).email,
        search: this.searchValue,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
      };

      this.exportReport(params)
        .then(() =>
          Swal.fire(
            "Success!",
            `Your request for report is pending. It will be sent to your email once it's ready.`,
            "success"
          )
        )
        .catch(() =>
          Swal.fire(
            "Failed!",
            `Your request for reports has failed.`,
            "warning"
          )
        );
    },
    async tableSorting(action) {
      var column = "";
      switch (action.sortBy) {
        case "store_name":
          column = "w.store_name";
          break;
        case "store_owner":
          column = "w.store_owner";
          break;
        case "status":
          column = "w.status";
          break;
        case "transaction_date":
          column = "w.txn_datetime";
          break;
        case "release_date":
          column = "l.release_datetime";
          break;
        case "remarks":
          column = "w.remarks";
          break;
        case "withdrawal_amount":
          column = "w.amount";
          break;
        case "wallet_type":
          column = "w.wallet_type";
          break;
        case "account_name":
          column = "w.account_name";
          break;
        case "account_number":
          column = "w.account_no";
          break;
        case "email":
          column = "w.recipient_email";
          break;
      }

      this.sortBy = column;
      this.sortOrder = action.sortDesc ? "DESC" : "ASC";
      await this.getCashout();
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{
                      mcpCashoutTotal
                    }}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right">
                <button class="btn btn-secondary" @click="getCashout">
                  <feather
                    type="refresh-ccw"
                    size="16"
                    class="icon nav-icon"
                  ></feather
                  >&nbsp;&nbsp; Refresh
                </button>
              </div>
              <!-- Search and button -->
              <div class="d-flex flex-wrap mt-3 mb-2 px-3 ta-right">
                <b-form-group description="Search keyword" class="me-2">
                  <form class="d-flex" @submit.prevent="getCashout">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none"
                        style="width: fit-content"
                        id="input-3"
                        v-model="searchValue.searchField"
                        :options="searchList"
                      ></b-form-select>
                    </b-form-group>

                    <b-input-group>
                      <b-form-input
                        class="rounded-0 rounded-end"
                        v-model="searchValue.keyword"
                      ></b-form-input>
                    </b-input-group>
                  </form>
                </b-form-group>

                <b-form-group
                  label-for="status"
                  description="Filter by status"
                  class="me-2 w-status"
                >
                  <b-form-select
                    class="form-select rounded-0 rounded-start rounded-end shadow-none"
                    v-model="searchValue.status"
                    :options="statusOptions"
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  label-for="cashoutType"
                  description="Filter by cashout type"
                  class="me-2 w-cashout-type"
                >
                  <b-form-select
                    class="form-select rounded-0 rounded-start rounded-end shadow-none"
                    v-model="searchValue.cashoutType"
                    :options="cashoutTypeOptions"
                  ></b-form-select>
                </b-form-group>

                <b-form-group description="Filter by date added" class="me-2 w-daterange">
                  <flat-pickr
                    v-model="searchValue.dateRange"
                    :config="rangeOptions"
                    placeholder="Select a date range"
                    class="form-control"
                  ></flat-pickr>
                </b-form-group>

                <b-button
                  variant="primary"
                  class="h-fit me-2 d-flex flex-row"
                  @click="getCashout"
                >
                  <i class="bx bx-search me-1 mt-1"></i>Search
                </b-button>
                <b-button
                  variant="primary"
                  class="h-fit me-2 d-flex flex-row"
                  @click="
                    isSearching = true;
                    onExport();
                  "
                >
                  <i class="uil uil-export me-1"></i>
                  Export
                </b-button>
              </div>
            </div>

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="mcpCashouts"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="tableSorting"
                >
                  <template #cell(request_reference_number)="data">
                    <div>
                      <b-link
                        @click="
                          $router.push({
                            path: `/kanto-ads/cashout/${data.item.id}`,
                          })
                        "
                      >
                        {{ data.item.txn_ref_id }}
                      </b-link>
                    </div>
                  </template>

                  <template #cell(store_name)="data">
                    <div>{{ data.item.store_name }}</div>
                  </template>

                  <template #cell(store_owner)="data">
                    <div>{{ data.item.store_owner }}</div>
                  </template>

                  <template #cell(mobile)="data">
                    <div>{{ data.item.sss_mobile_no != 0 ? data.item.sss_mobile_no : '' }}</div>
                  </template>

                  <template #cell(status)="data">
                    <div
                      :class="{
                        'pending-color-code': data.item.status == 'pending' || data.item.status == 'processing',
                        'on-hold-color-code': data.item.status == 'on hold',
                        'confirmed-color': data.item.status == 'confirmed' || data.item.status == 'success',
                        'declined-color-code': data.item.status == 'rejected' || data.item.status == 'failed',
                      }"
                      class="text-capitalize"
                    >
                      {{ data.item.status != null || data.item.status != "" ? data.item.status : data.item.status = 'pending' }}
                    </div>
                  </template>
                  
                  <template #cell(transaction_date)="data">
                    <div>{{ data.item.txn_datetime | formatDate }}</div>
                  </template>

                  <template #cell(release_date)="data">
                    <div>{{ data.item.release_datetime | formatDateOnly }}</div>
                  </template>

                  <template #cell(remarks)="data">
                    <div class="text-truncate" style="width: 120px">
                      {{ data.item.remarks != "null" ? data.item.remarks : '' }}
                    </div>
                  </template>

                  <template #cell(withdrawal_amount)="data">
                    <div>PHP {{ data.item.amount }}</div>
                  </template>

                  <template #cell(wallet_type)="data">
                    <div>{{ data.item.wallet_type }}</div>
                  </template>

                  <template #cell(account_name)="data">
                    <div>{{ data.item.account_name }}</div>
                  </template>

                  <template #cell(account_number)="data">
                    <div>{{ data.item.account_no }}</div>
                  </template>

                  <template #cell(email)="data">
                    <div>{{ data.item.recipient_email }}</div>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="mcpCashoutTotal == 0">
              <span>No data to display.</span>
            </div>
            <div
              class="row g-0 text-center text-sm-start"
              v-if="mcpCashoutTotal > 10"
            >
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label"
                        >Display:</label
                      >
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select
                            class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="getCashout"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                      v-if="mcpCashoutTotal > perPage"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="mcpCashoutTotal"
                        @input="getCashout"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
<style>
.custom-checkbox-method label {
  margin-left: 10px;
}

.custom-checkbox-method input {
  margin-left: 15px;
}

.required-input {
  color: red;
}

.calendar-icon {
  display: block;
  font-size: 20px;
  padding: 8px;
  background-color: grey;
}

.w-status {
  width: 11rem;
}

.w-cashout-type {
  width: 12.9rem;
}

.w-daterange {
  width: 12.9rem;
}

.pending-color-code {
  color: #831118 !important;
}

.on-hold-color-code {
  color: #dc7512 !important;
}

.confirmed-color {
  color: #508f30 !important;
}

.declined-color-code {
  color: #868686 !important;
}
</style>
